// Third Party Imports
import React from 'react';
import PropTypes from 'prop-types';
import {SVG_ALERT_WARNING} from '../../images/alert-icon';
import {CLOSE__12} from '@homeaway/svg-defs/lib/defs/CLOSE__12';
import {SVGIcon} from '@homeaway/react-svg';

// Relative Imports
import './ErrorAlert.less';

class ErrorAlert extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        let {
            message,
            dismissFormAlert,
            innerComponent
        } = this.props;

        return (
            <div className="error-alert">
                <div className="error-alert-content">
                    <div className="wrapper">
                        <div className="content-holder">
                            <div>
                                <div className="alert-icon-holder"><SVGIcon markup={SVG_ALERT_WARNING}/></div>
                                <div className="wrapper">
                                    <div className="text-holder">
                                        {
                                            // eslint-disable-next-line react/no-danger
                                            <span className="error-text" dangerouslySetInnerHTML={{__html: message}}/>
                                        }
                                        {innerComponent}
                                    </div>
                                </div>
                                <div className="close-icon-holder"><button onClick={dismissFormAlert} className="alert-close-button"><SVGIcon markup={CLOSE__12}/></button></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ErrorAlert.propTypes = {
    messageKey: PropTypes.string,
    dismissAlert: PropTypes.func
};

export default ErrorAlert;
